import { setSpecificMessage, excludes } from "valibot";
setSpecificMessage(
  excludes,
  (issue) => `Contenu invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);